import styled from "styled-components";
import wineImg from "../../assets/img/wine.jpg";

export const WineContainer = styled.div`
    display: flex;  
    height: 163px;
    width: 100%;
`;

export const ImageContainer = styled.div`
    height: 100%;
    width: 100%;
    background-image: url(${wineImg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;

export const TextContainer = styled.div`

    position: relative;
    width: 100%;
    height: 100%;
    //transform: translate(-50%, -50%);
    text-align: center;
    /* Optional: Add a semi-transparent background for readability */
    background-color: rgba(0, 0, 0, 0.6);
    justify-content: center;
    align-content: center;
`;

export const TextParagraph = styled.div`
    color: #e2dddd;
`;


